import { useEffect } from "react";

// Every browser tab reads "<Page name> | WES AUSTRALIA". Pages with no name of
// their own (the home page) show the brand on its own.
export const BRAND_TITLE = "WES AUSTRALIA";

export const buildPageTitle = (pageName) => {
  const name = typeof pageName === "string" ? pageName.trim() : "";
  return name ? `${name} | ${BRAND_TITLE}` : BRAND_TITLE;
};

export const setPageTitle = (pageName) => {
  document.title = buildPageTitle(pageName);
};

/**
 * For pages whose name only exists once their data has loaded - product name,
 * category name, brand name, search term. Pass a falsy value while it is still
 * loading: the static title the router already set stays on screen until the
 * real one arrives, so there is never an empty tab.
 */
export const usePageTitle = (pageName) => {
  useEffect(() => {
    if (!pageName) return;
    setPageTitle(pageName);
  }, [pageName]);
};
